import { TypedDocumentNode } from 'providers/tanstack-query/types'
import { gql } from 'providers/tanstack-query/utils'
import { PageForSnackbarDTO } from './types'

export const PAGE_CREATE_FRAGMENT: TypedDocumentNode<PageForSnackbarDTO> = gql`
  fragment PageCreateFragment on Page {
    id
    name
  }
`
